var _defs, _rect, _rect2, _path, _path2, _path3, _path4, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path5, _path6, _path7, _path8, _path9, _rect9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighstreet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Highstreet",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 347.692,
    height: 45.688,
    viewBox: "0 0 347.692 45.688",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01f1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6244f9"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16649",
    "data-name": "Rectangle 16649",
    width: 12.43,
    height: 22.746,
    transform: "translate(21.121 22.746)",
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16650",
    "data-name": "Rectangle 16650",
    width: 9.944,
    height: 27.345,
    transform: "translate(42.261 18.343)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_99242",
    "data-name": "Path 99242",
    d: "M170.872,14.124h-9.748V6H153V32h8.124V23.872H179V6h-8.124Z",
    transform: "translate(95.583 3.748)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99243",
    "data-name": "Path 99243",
    d: "M192.872,14.124h-9.748V6H175V32h8.124V23.872H201V6h-8.124Z",
    transform: "translate(109.327 3.748)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99244",
    "data-name": "Path 99244",
    d: "M117.749,0V9.748H108v8.124h9.748v27.62h17.872V37.369h-9.75v-19.5h9.75V9.748h-9.75V0Z",
    transform: "translate(67.47 0)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99245",
    "data-name": "Path 99245",
    d: "M130,0V45.492h8.124V17.872h9.75V27.62h9.747V9.748h-19.5V0Z",
    transform: "translate(81.214 0)",
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16651",
    "data-name": "Rectangle 16651",
    width: 9.944,
    height: 9.944,
    transform: "translate(256.608)",
    fill: "url(#linear-gradient)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16657",
    "data-name": "Rectangle 16657",
    width: 9.944,
    height: 9.944,
    transform: "translate(42.046)",
    fill: "url(#linear-gradient)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16652",
    "data-name": "Rectangle 16652",
    width: 9.944,
    height: 9.944,
    transform: "translate(292.353)",
    fill: "url(#linear-gradient)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16653",
    "data-name": "Rectangle 16653",
    width: 17.402,
    height: 9.944,
    transform: "translate(256.608 35.549)",
    fill: "url(#linear-gradient)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16654",
    "data-name": "Rectangle 16654",
    width: 17.402,
    height: 9.944,
    transform: "translate(292.353 35.549)",
    fill: "url(#linear-gradient)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16655",
    "data-name": "Rectangle 16655",
    width: 9.944,
    height: 22.942,
    transform: "translate(118.408 22.746)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99246",
    "data-name": "Path 99246",
    d: "M60,0V45.492H71.372V22.746h9.75V11.373h-9.75V0Z",
    transform: "translate(37.484 0)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99247",
    "data-name": "Path 99247",
    d: "M206.749,0V9.748H197v8.124h9.748v27.62h17.872V37.369h-9.75v-19.5h9.75V9.748h-9.75V0Z",
    transform: "translate(123.071 0)",
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99248",
    "data-name": "Path 99248",
    d: "M0,0V45.492H11.373V22.746h9.748V11.373H11.373V0Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99249",
    "data-name": "Path 99249",
    d: "M54.87,17.872H45.124V9.75H54.87ZM45.124,0V9.748H37V27.62H54.87v8.124H37v9.748H64.62V0Z",
    transform: "translate(23.115)",
    fill: "url(#linear-gradient)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_99250",
    "data-name": "Path 99250",
    d: "M94.748,0V8.124H85v19.5h19.5v8.124h8.124V17.872H94.748V9.748h19.5V0Z",
    transform: "translate(53.102 0)",
    fill: "url(#linear-gradient)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16656",
    "data-name": "Rectangle 16656",
    width: 17.402,
    height: 9.944,
    transform: "translate(140.295 35.744)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighstreet);
export default __webpack_public_path__ + "static/media/highstreet.6b2eb4aa6218fdebe0d776b27c2dd593.svg";
export { ForwardRef as ReactComponent };